import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_cloud",
  "use": "svg_cloud-usage",
  "viewBox": "0 0 16 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 11\" id=\"svg_cloud\"><path d=\"M8.994 0a3.989 3.989 0 0 0-3.609 2.293 3.99 3.99 0 1 0-1.393 7.728h8.993a3.015 3.015 0 0 0 0-6.03A3.992 3.992 0 0 0 8.994 0Z\" fill=\"#FFF\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol